module.exports = __webpack_public_path__ + "static/media/transgender.c5094526.svg";